// extracted by mini-css-extract-plugin
export default {"loader":"LoaderSpinner_loader__tALsx","spin":"LoaderSpinner_spin__rZYbM"};